import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Snackbar, Alert, Skeleton } from "@mui/material";
import { useUser } from "../../contexts/userContext";
import { useFollow } from "../../contexts/followContext";

const FollowButton = ({ bloger }) => {
  const { userData } = useUser();
  const { followMap, getBlogerId, toggleFollow } = useFollow();
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [ready, setReady] = useState(false);      // 是否初始化完成
  const [notFound, setNotFound] = useState(false); // 博主是否不存在

  const followed = followMap[bloger] ?? false;

  useEffect(() => {
    if (!userData) return;

    getBlogerId(bloger)
      .then(() => {
        setReady(true);
        setNotFound(false);
      })
      .catch((err) => {
        console.warn(err);
        setReady(true);
        setNotFound(true); // 获取失败，标记博主不存在
      });
  }, [bloger, userData, getBlogerId]);

  const handleClick = async (e) => {
    e.stopPropagation();
    if (!userData) {
      setShowToast(true);
      return;
    }

    setLoading(true);
    try {
      await toggleFollow(bloger);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 未初始化显示 Skeleton
  if (!ready) {
    return <Skeleton variant="rectangular" width={70} height={28} sx={{ borderRadius: "14px" }} />;
  }

  // 博主不存在，按钮不显示
  if (notFound) return null;

  return (
    <>
      <Button
        variant="outlined"
        disabled={loading}
        onClick={handleClick}
        sx={{
          minHeight: 28,
          fontSize: 12,
          borderRadius: "14px",
          textTransform: "none",
          fontWeight: 600,
          px: 1.5,
          py: 0.3,
          transition: "all 0.25s ease",
          color: followed ? "#444" : "#fff",
          backgroundColor: followed ? "#fff" : "#000",
          borderColor: followed ? "#ccc" : "#000",
          "&:hover": {
            backgroundColor: followed ? "#f5f5f5" : "#222",
            borderColor: followed ? "#bbb" : "#000",
          },
        }}
      >
        {loading ? (
          <CircularProgress size={14} sx={{ color: followed ? "#555" : "#fff" }} />
        ) : followed ? (
          "正在关注"
        ) : (
          "关注"
        )}
      </Button>

      <Snackbar
        open={showToast}
        autoHideDuration={3000}
        onClose={() => setShowToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShowToast(false)}
          severity="warning"
          sx={{ backgroundColor: "rgba(0,0,0,0.7)", color: "#fff", fontWeight: 500 }}
        >
          请先登录，点击右上角头像
        </Alert>
      </Snackbar>
    </>
  );
};

export default FollowButton;
